<h3>{{ data.titulo }}</h3>
<div class="visor">
    <div class="objViewer" #objViewer></div>
</div>
